import React from 'react'
import PropTypes from 'prop-types'
import {DrawerContent as RmwcDrawerContent} from '@rmwc/drawer'
//import '@rmwc/drawer/styles'
import '@rmwc/drawer/styles'

const DrawerContent = ({children, ...otherProps}) => <RmwcDrawerContent {...otherProps}>{children}</RmwcDrawerContent>

DrawerContent.propTypes = {
  children: PropTypes.any
}

export {DrawerContent}
